import { CoverLevelOption, CoverLevelOptionSelector, Quote } from './types'

export const getCoverLevelOption = (quote: Quote | undefined) =>
  quote?.availableCoverLevelOptions.find((it) => it.active)

export const isMatchingCoverLevelOption =
  (selection: CoverLevelOptionSelector | undefined) =>
  (option: CoverLevelOption | undefined) =>
    option?.coverLevel === selection?.coverLevel &&
    option?.paymentScheduleType === selection?.paymentScheduleType
